export default {
  'completeprofile.completeprofile':
    'Starten, Profilprozess zu vervollständigen ',
  'completeprofile.maintext':
    'Um Ihre Profilelemente zu vervollständigen und positive Punkte zu erhalten, versuchen Sie bitte, Ihr Profil zu vervollständigen, indem Sie auf Profil vervollständigen klicken',
};
